export default {
    getItem: (state) => (field) => state[field],

    getNineDots: state => state.showModal,

}